import type { ReactNode } from 'react'
import { CheckCircle2, Clock, Info, TriangleAlert, Circle, type LucideIcon } from 'lucide-react'
import { cn } from '@/lib/utils'

export type StatusTone = 'success' | 'warning' | 'danger' | 'info' | 'neutral'

const tones: Record<StatusTone, { className: string; Icon: typeof Info }> = {
  success: { className: 'bg-success-bg text-success', Icon: CheckCircle2 },
  warning: { className: 'bg-warning-bg text-warning', Icon: Clock },
  danger: { className: 'bg-danger-bg text-danger', Icon: TriangleAlert },
  info: { className: 'bg-info-bg text-info', Icon: Info },
  neutral: { className: 'bg-border-subtle/60 text-fg-muted', Icon: Circle },
}

/** Status is always icon + text, never colour alone (guide §3). */
export function StatusBadge({ tone = 'neutral', children, className, icon }: { tone?: StatusTone; children: ReactNode; className?: string; icon?: LucideIcon }) {
  const { className: toneClass, Icon: defaultIcon } = tones[tone]
  const Icon = icon ?? defaultIcon
  return (
    <span className={cn('inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-caption font-medium', toneClass, className)}>
      <Icon aria-hidden className="size-3.5 shrink-0" />
      {children}
    </span>
  )
}
